import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader-advanced';
import SessionTable from '../components/Session/SessionTable.js';
import SessionMenu from '../components/Session/SessionMenu.js';
import { fetchSessions, fetchSessionsByDate } from '../actions/sessions.js';
import { setBreadCrumbs } from '../actions/breadcrumbs.js';
import { setActiveSession } from '../actions/application.js';
import PropTypes from 'prop-types';
import _ from 'lodash';

class SessionsContainer extends Component {
  constructor(props) {
        super(props);        
        this.state = {
            sessions    :  props.sessions,
            filtered    :  props.sessions,
            isFiltered  : false,
            startDate   : props.startDate,                         
            endDate     : props.endDate,
        }        
        this.filterByBeamline = this.filterByBeamline.bind(this);              
  }

  filterByBeamline(beamlines){        
    if (beamlines.length === 0){      
       this.setState({
          filtered : this.state.sessions,
          isFiltered : true
        });        
    }
    else{
      var sessions = {...this.state.sessions};
      sessions.data = _.filter(sessions.data, function(o){               
          for (var i =0; i < beamlines.length; i++){
              if (beamlines[i].toUpperCase().trim() === o.beamLineName.toUpperCase().trim()){
                return true;
              }
          }
          return false;
      });      
      this.setState({
        filtered : sessions,
        isFiltered : true
      })
    }
  }

  render() {       
    let sessions = this.props.sessions;
    if (this.state.isFiltered){
        sessions = this.state.filtered;
    }
    
    if ((!this.props.user) || (!this.props.user.token) || (!this.props.sessions)) {         
      return null;
    }
    return (
      <div>
        <SessionMenu 
              startDate={this.props.startDate} 
              endDate={this.props.endDate} 
              filterByBeamline={this.filterByBeamline} 
              beamlines={this.props.configuration.beamlines} 
              user={this.props.user}              
              history={this.props.history} 
              fetchSessionsByDate={this.props.fetchSessionsByDate}
              setBreadCrumbs={this.props.setBreadCrumbs} 
              />
        <Loader show={this.props.sessions.fetching} >
            <SessionTable history={this.props.history} sessions={sessions} setActiveSession={this.props.setActiveSession} configuration={this.props.configuration}></SessionTable>
        </Loader>        
      </div>);
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    sessions : state.sessions,
    configuration : state.configuration
  };
}

function mapDispatchToProps(dispatch) {
  return {     
    fetchSessionsByDate: (server, token, startDate, endDate) => dispatch(fetchSessionsByDate(server, token, startDate, endDate)),
    fetchSessions: (server, token) => dispatch(fetchSessions(server, token)),
    setActiveSession: (sessionId, title) => dispatch(setActiveSession(sessionId, title)),
    setBreadCrumbs : (breadCrumbsList) => dispatch(setBreadCrumbs(breadCrumbsList))

    
  };
}

SessionsContainer.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionsContainer);










// WEBPACK FOOTER //
// ./src/containers/SessionsContainer.js